/* KŌSMOPELLIS — galerie mobile : ligne de progression à la place des vignettes (≤749px).
   Additif : retirer la balise script dans sections/main-product.liquid pour désactiver. */
(function () {
  function setup(list) {
    if (list.dataset.kpProgress) return;
    list.dataset.kpProgress = '1';
    var items = list.querySelectorAll('.product__media-item');
    if (items.length < 2) return;
    var bar = document.createElement('div');
    bar.className = 'kp-gallery-progress';
    bar.setAttribute('role', 'progressbar');
    bar.setAttribute('aria-label', 'Position dans la galerie');
    bar.innerHTML = '<span class="kp-gallery-progress__fill"></span>';
    var host = list.closest('slider-component') || list;
    host.insertAdjacentElement('afterend', bar);
    var fill = bar.firstElementChild, raf = null;
    function update() {
      raf = null;
      // image active = celle dont le bord gauche est le plus proche de la position de scroll (snap Dawn)
      var base = items[0].offsetLeft, idx = 0, best = Infinity;
      items.forEach(function (it, i) { var d = Math.abs((it.offsetLeft - base) - list.scrollLeft); if (d < best) { best = d; idx = i; } });
      if (list.scrollLeft >= list.scrollWidth - list.clientWidth - 2) idx = items.length - 1; // bout de piste
      fill.style.width = ((idx + 1) / items.length) * 100 + '%';
      bar.setAttribute('aria-valuenow', idx + 1);
      bar.setAttribute('aria-valuemax', items.length);
    }
    list.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function init() { document.querySelectorAll('.product__media-list').forEach(setup); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();

/* Prix par patch sur les cartes Kaching : calculé à partir du prix affiché et du nombre de patchs
   écrit dans le sous-titre Kaching (« 8 patchs … »). Retirer ce bloc pour désactiver. */
(function () {
  // 19/10 : lecture FR et EN (« 62,90 € », « €62.90 », « 1 234,56 € ») ; le prix par patch reprend le format du prix affiché.
  function parsePrice(t) {
    var m = (t || '').match(/\d[\d\s  .,]*\d|\d/); if (!m) return NaN;
    var s = m[0].replace(/[\s  ]/g, ''), c = s.lastIndexOf(','), d = s.lastIndexOf('.');
    var dec = Math.max(c, d);
    if (dec > -1 && s.length - dec - 1 === 2) s = s.slice(0, dec).replace(/[.,]/g, '') + '.' + s.slice(dec + 1); else s = s.replace(/[.,]/g, '');
    return parseFloat(s);
  }
  function fmt(n, sample) {
    var euroFirst = /€\s*\d/.test(sample || ''), comma = /\d,\d{2}(?!\d)/.test(sample || '') || !/\d\.\d{2}(?!\d)/.test(sample || '');
    var v = n.toFixed(2); if (comma) v = v.replace('.', ',');
    return euroFirst ? '€' + v : v + ' €';
  }
  function apply() {
    document.querySelectorAll('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar').forEach(function (bar) {
      var sub = bar.querySelector('.kaching-bundles__bar-subtitle'), price = bar.querySelector('.kaching-bundles__bar-price');
      if (!sub || !price) return;
      // Correctif 18/10 : recalcul à chaque changement de prix (achat unique ↔ abonnement −15 %) ; avant, l'étiquette
      // n'était jamais mise à jour une fois posée (Yeux Essentiel abonnement : 53,47 € mais « 7,86 €/patch » au lieu de 6,68).
      var unit = sub.querySelector('.kp-unit');
      var base = unit ? sub.textContent.replace(unit.textContent, '') : sub.textContent;
      var m = base.match(/(\d+)\s*(?:patchs?|patches)\b/i); if (!m) return;
      var p = parsePrice(price.textContent);
      if (!p || !+m[1]) return;
      var text = '· ' + fmt(p / +m[1], price.textContent) + '/patch';
      if (unit) { if (unit.textContent !== text) unit.textContent = text; return; }
      var span = document.createElement('span'); span.className = 'kp-unit'; span.textContent = text; span.style.whiteSpace = 'nowrap';
      sub.appendChild(document.createTextNode(' ')); sub.appendChild(span);
    });
  }
  // Correctif 18/10 (2) : au plus 150 ms après le 1er changement (avant : attendait 150 ms de calme ; après un défilement, Klaviyo et les images
  // modifient la page en continu et le prix par patch restait faux 3 à 6 s).
  var t = null; function schedule() { if (t) return; t = setTimeout(function () { t = null; apply(); }, 150); }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  schedule();
})();

/* 20/09/2026 — Offre « 1 mois » présélectionnée à l'arrivée sur les fiches patch (demande d'Aris : un sticky à 99,90 €
   dès le 1er écran faisait fuir). Une seule fois, jamais après un choix de la visiteuse ; le Pack Visage n'est pas concerné.
   Retirer ce bloc pour revenir à la présélection définie dans Kaching. */
(function () {
  if (/cure-visage-complet/.test(location.pathname)) return;
  var done = false, touched = false;
  document.addEventListener('pointerdown', function (e) { if (e.isTrusted && e.target.closest && e.target.closest('.kaching-bundles__bar')) touched = true; }, true);
  function pick() {
    if (done || touched) return;
    var bars = document.querySelectorAll('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar');
    if (!bars.length) return;
    var target = null;
    bars.forEach(function (b) {
      if (target) return;
      var t = ((b.querySelector('.kaching-bundles__bar-title') || {}).textContent || '') + ' ' + ((b.querySelector('.kaching-bundles__bar-subtitle') || {}).textContent || '');
      if (/(^|[^0-9])1[\s\-‐‑– ]*(?:mois|month)\b/i.test(t)) target = b; // 19/10 : FR et EN (« 1 mois », « 1 month », « 1-month »)
    });
    done = true;
    if (!target || target.classList.contains('kaching-bundles__bar--selected')) return;
    var el = target.querySelector('label.kaching-bundles__bar-container') || target.querySelector('input[type=radio]') || target;
    el.click();
  }
  var tries = 0, iv = setInterval(function () { tries++; if (document.querySelector('.kaching-bundles__bar--selected')) { clearInterval(iv); setTimeout(pick, 250); } else if (tries > 40) clearInterval(iv); }, 200);
})();

(function () {
  function preserveSelectedOffer(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    var target = event.target;
    if (!target || !target.closest) return;
    var main = target.closest('.kaching-bundles__bar-main');
    if (!main || target.closest('a, button, input, select, textarea, [role="checkbox"], [role="combobox"]')) return;
    var bar = main.closest('.kaching-bundles__bar');
    var block = main.closest('.kaching-bundles__block');
    if (!bar || !block || block.dataset.abTestVariant !== 'B') return;
    if (!bar.classList.contains('kaching-bundles__bar--selected')) return;
    if (bar.closest('.kaching-bundles__subscriptions')) return;
    event.preventDefault();
    event.stopPropagation();
  }
  document.addEventListener('click', preserveSelectedOffer, true);
  document.addEventListener('keydown', preserveSelectedOffer, true);
})();

(function () {
  function setupStock(stock) {
    if (stock.dataset.kpStockReady) return;
    stock.dataset.kpStockReady = '1';
    var scope = stock.closest('product-info') || stock.closest('section');
    if (!scope) return;
    var variants;
    try { variants = JSON.parse(stock.dataset.kpStockVariants); } catch (error) { return; }
    var text = stock.querySelector('[data-kp-stock-text]');
    var pending = false;
    function sync() {
      pending = false;
      var input = scope.querySelector('input.product-variant-id[name="id"]') || scope.querySelector('input[name="id"]');
      var id = input && input.value ? input.value : stock.dataset.kpStockInitial;
      var variant = variants.find(function (item) { return item.id === id; });
      var quantity = variant ? variant.low : 0;
      var message = quantity > 9 ? stock.dataset.kpStockCount.replace('__COUNT__', String(quantity)) : stock.dataset.kpStockLow;
      if (text && text.textContent !== message) text.textContent = message;
      stock.classList.toggle('hidden', quantity < 1);
    }
    function schedule() {
      if (pending) return;
      pending = true;
      setTimeout(sync, 100);
    }
    scope.addEventListener('change', schedule);
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        return record.type === 'childList' ||
          record.target.matches('.kaching-bundles__bar, input.product-variant-id');
      })) schedule();
    }).observe(scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'value'] });
    sync();
  }
  function initStock() { document.querySelectorAll('[data-kp-stock-variants]').forEach(setupStock); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initStock) : initStock();
  document.addEventListener('shopify:section:load', initStock);
})();
